<script>
export default {
  name: 'SearchForm',
  props: {
    placeholder: {
      type: String,
      default: 'Rechercher un prospect...'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchQuery: this.value
    }
  },
  watch: {
    value (newValue) {
      this.searchQuery = newValue
    },
    searchQuery (newValue) {
      this.$emit('input', newValue)
      this.$emit('search', newValue)
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.$emit('submit', this.searchQuery)
    },
    clearSearch () {
      this.searchQuery = ''
      this.$emit('clear')
    }
  }
}
</script>

<template>
  <form
    class="search-form"
    aria-label="Formulaire de recherche"
    novalidate
    @submit="handleSubmit"
  >
    <div class="search-form__wrapper">
      <svg
        class="search-form__icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
      <input
        v-model="searchQuery"
        type="text"
        class="search-form__input"
        :placeholder="placeholder"
        aria-label="Champ de recherche"
      >
      <button
        v-if="searchQuery"
        type="button"
        class="search-form__clear"
        aria-label="Effacer la recherche"
        @click="clearSearch"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  </form>
</template>

<style scoped>
.search-form {
  width: 100%;
  max-width: 415px;
}

.search-form__wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.search-form__icon {
  position: absolute;
  left: 1rem;
  color: #666666;
  pointer-events: none;
}

.search-form__input {
  width: 100%;
  padding: 0.75rem 3rem 0.75rem 3rem;
  font-family: "Lato", sans-serif;
  font-size: 1rem;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  background-color: #FFFFFF;
  color: #000000;
  transition: all 0.2s ease;
}

.search-form__input::placeholder {
  color: #999999;
}

.search-form__input:focus {
  outline: none;
  border-color: #193066;
  box-shadow: 0 0 0 3px rgba(25, 48, 102, 0.1);
}

.search-form__clear {
  position: absolute;
  right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  background: none;
  border: none;
  color: #666666;
  cursor: pointer;
  transition: color 0.2s ease;
}

.search-form__clear:hover {
  color: #000000;
}

.search-form__clear:focus {
  outline: none;
  color: #193066;
}

@media (max-width: 768px) {
  .search-form__input {
    padding: 0.625rem 2.5rem 0.625rem 2.5rem;
    font-size: 0.9rem;
  }

  .search-form__icon {
    left: 0.75rem;
    width: 18px;
    height: 18px;
  }

  .search-form__clear {
    right: 0.75rem;
  }
}
</style>


// WEBPACK FOOTER //
// search.vue?f472bfc0